import {TreatmentTarget} from './treatment_target'
export class SimRingTreatment extends TreatmentTarget {
    
  constructor() {
    super();
  }
  
  setTarget(target) {
    this.target = target
  }

  addNewItem() {
   let newSimRingItem = document.createElement('simring-item');
   this.querySelector('.simring_form_group').appendChild(newSimRingItem);
  }

  validate() {
    let response = {}
    this.querySelectorAll('input').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getIcon() {
    return 'fa-list'
  }

  static getType() {
    return "SIMRING"
  }

  getData() {
    let target = 
      { 
        target_name: "SIMRING",
        target_type: "SIMRING", 
        ring_to_endpoint: null,
        ivr_target_audio_id: null,
        ivr_choice_timeout: null,
        children: [],
        actions: []
      }

    this.querySelectorAll("simring-item").forEach(function(sim_ring_element, index) {
      let ring_to_endpoint = sim_ring_element.querySelector("input").value;
      let child = {
        ivr_option: null, 
        destination: { 
          target_name: `Ring ${ring_to_endpoint}`,
          target_type: "ENDPOINT", 
          ring_to_endpoint: ring_to_endpoint,
          ivr_target_audio_id: null,
          ivr_choice_timeout: null,
          children: []
        }
      }
      target.children.push(child)
    });

    return target;
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action" data-action_type=SIMRING>
        <div class="panel panel-default">
          <h4>Simultaneous Ring</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="form-group">
              <label for="exampleInputPassword1">Simultaneous Ring Targets</label><br/>
              <div class="simring_form_group">
              </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Sales Rep is being Called</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
    `;

    if(this.target == null) {
      this.querySelector(".simring_form_group").appendChild(document.createElement("simring-item"));
    }
    else {
      this.target.children.map(function(target_child, i) {
          let simRingItem = document.createElement("simring-item");
          simRingItem.setTarget(target_child.destination);
          this.querySelector(".simring_form_group").appendChild(simRingItem);
        }.bind(this)
      );
    }
    super.connectedCallback();
  }
}
customElements.define('simring-treatment', SimRingTreatment);

class SimRingItem extends HTMLElement {
  
  constructor() {
    super();
  }
  
  setTarget(target) {
    this.target = target
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="sim_ring_form_item" style="margin-top: 3px;">
                    <input type="text" is="ring-to-endpoint" class="form-control sim_ring_number" data-key="sim_ring_number" placeholder="(123) 444-5566 or SIP Target" style="width: 90%;
                display: inline-block;" value="${this.target != null ? this.target.ring_to_endpoint : ""}">
                  <a href="#" class="remove_sim_ring" style="margin-left: 10px;"><i class="fa fa-minus"></i></a>
                  <a href="#" class="add_sim_ring" style="margin-left: 10px;"><i class="fa fa-plus"></i></a>
                </div>`;
    let _this = this;
    this.querySelector(".remove_sim_ring").addEventListener('click', function(event) {
        event.preventDefault();
        _this.remove();
      });
    this.querySelector(".add_sim_ring").addEventListener('click', function(event) {
        event.preventDefault();
        _this.closest("simring-treatment").addNewItem();
      });
  }
}

customElements.define('simring-item', SimRingItem);